import styles from "./styledForm.module.scss";

export const FormControlTextarea = (props) => {
  const { style, className = "", children } = props;
  return (
    <textarea {...props} className={`${styles.textarea_form} ${className}`} style={style}>
      {children}
    </textarea>
  );
};

export const FormContainer = (props) => {
  const { style, className = "", children } = props;
  return (
    <div className={`${styles.form_container} ${className}`} style={style}>
      {children}
    </div>
  );
};

export const FormControl = (props) => {
  const { style, className = "" } = props;
  return (
    <input {...props} className={`${styles.input_form} ${className}`} style={style} />
  );
};

export const TextArea = (props) => {
  const { style, className = "", children } = props;
  return (
    <div className={`${styles.paragraph} ${className}`} style={style}>
      {children}
    </div>
  );
};
